<template>
  <div class="page-container" ref="container">
    <div class="page-box box-cls-1">
      <div class="page-content">
        <header>
          <img src="../assets/major/logo.png" alt="默往专业版" title="默往专业版"/>
          <a href="https://www.mostonetech.top/" target="_blank" title="默往官网">默往官网</a>
        </header>
        <div class="main">
          <div class="left-box">
            <h1>默往专业版<br/>专业提供IM私有化部署解决方案</h1>
            <div class="text-cls">默往专业版依托默往APP开发<br/>
              具有稳定的性能，支持高并发量，丰富的特色功能<br/>
              完善的风控体系，较强的防攻击能力<br/>
              提供IM基础功能及特色功能，支持部署到指定服务器
            </div>
            <div class="btn-cls" @click="showDialog">咨询价格</div>
          </div>
          <img class="center-box" src="../assets/major/phone.png" alt/>
          <div class="right">
            <div class="pc-box">
              <h1>默往APP</h1>
              <p>重要事默往说</p>
              <div class="btn">
                <div class="download iphone"
                     @click="download('https://apps.apple.com/cn/app/id1408526658')"
                >
                  iPhone
                </div>
                <div class="download android"
                     @click="download('https://sj.qq.com/myapp/detail.htm?apkName=com.mostone.life')"
                >
                  Android
                </div>
              </div>
              <div class="qrcode">
                <img src="../assets/qrcode.png" alt/>
              </div>
              <div style="text-align: center; width: 120px;">扫码下载</div>
            </div>
            <div class="ph-box">
              <div class="flex-box"><h1>默往APP<span>-</span>重要事默往说</h1></div>
<!--              <div class="down-btn-cls" @click="downloadh5">下 载</div>-->
              <a class="down-btn-cls" href="https://www.mostonetech.top/" target="_blank" title="默往官网">默往官网</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page-box box-cls-2">
      <div class="page-content">
        <h1>IM基础功能</h1>
        <div class="flex-box">
          <div class="flex-1" v-for="(item, index) in baseList" :key="index">
            <img class="flex-img-cls" :src="item.image" alt="">
            <p class="item-title-cls">{{ item.title }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="page-box box-cls-3">
      <div class="page-content">
        <h1>特色功能</h1>
        <h4>基于默往APP的特色功能，可以下载默往APP体验</h4>
        <div class="flex-box">
          <div class="flex-1" v-for="(item, index) in featureList" :key="index">
            <img class="flex-img-cls" :src="item.image" alt="">
            <p class="item-title-cls">{{ item.title }}</p>
          </div>
        </div>
        <div class="bottom-btn">
          <div class="btn-cls" @click="showDialog">咨询价格</div>
        </div>
      </div>
    </div>

    <footer>
      <router-link to="/user_proto" active-class="" exact-active-class="">用户服务协议</router-link> |
      客服热线: 400-600-8017
      <br/>Copyright © 2019-2020 厦门默往科技有限公司
      <a style="margin-left: 8px" target="_blank" href="http://beian.miit.gov.cn/">
        闽ICP备18014382号
      </a>
      <br/>
      <a target="_blank"
         href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020302033744"
      ><img src="http://www.beian.gov.cn/img/new/gongan.png" alt="" style="position: relative;top: 5px"> 闽公网安备
        35020302033744号 </a>
    </footer>

    <!--  弹窗  -->
    <el-dialog title="私有化部署咨询" :visible.sync="open" :width="wdithNum" custom-class="dialog-cls" @close="closeFn" :close-on-click-modal="false">
      <template v-if="!submitSuccess">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="您的称呼" prop="name">
            <el-input
              v-model.trim="form.name"
              placeholder="请输入您的称呼"
              clearable
              maxlength="15"
            />
          </el-form-item>
          <el-form-item label="您的手机号" prop="cell_phone">
            <el-input
              v-model.trim="form.cell_phone"
              placeholder="请输入您的手机号"
              clearable
              maxlength="11"
            />
          </el-form-item>
          <el-form-item prop="code" label="手机验证码">
            <div style="height: 40px;display: flex">
              <el-input
                class="flex-1"
                v-model.trim="form.code"
                placeholder="请输入验证码"
                style="margin-right: 10px"
                maxlength="4"
              />
              <el-button
                v-if="codeshow"
                style="cursor:pointer;height: 38px;"
                type="primary"
                size="small"
                @click="getCodeFn()"
                class="code-btn"
              >
                {{ showtext }}
              </el-button>
              <el-button
                v-if="!codeshow"
                style="cursor:pointer;height: 38px;"
                type="info"
                size="small"
                @click="getCodeAgain()"
                class="code-btn"
              >
                重新获取{{ countNum }}s
              </el-button>
            </div>
          </el-form-item>

          <div class="btn-cls" @click="submitForm">提交咨询</div>
          <div class="btn-tag-cls">提交以后工作人员将1-3个工作日内联系你</div>
        </el-form>
      </template>
      <template v-else>
        <div class="success-box">
          <i class="el-icon-success"></i>
          <div class="title-cls">申请信息已提交</div>
          <p>姓名：{{form.name}}</p>
          <p>手机号：{{form.cell_phone}}</p>
          <div class="success-tag">工作人员将在1-3个工作日内与您联系，<br />请耐心等待。</div>
          <div class="btn-cls" @click="closeFn">好的，我知道了</div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import { addApply, getCode } from '../api/apply'

export default {
  name: 'marjor',
  data () {
    const checkPhone = (rule, value, callback) => {
      const reg = /^1[3456789]\d{9}$/
      if (reg.test(value)) {
        callback()
      } else {
        callback('请输入正确的手机号')
      }
    }
    return {
      ctx: null,
      animationObj: [],
      canvasW: null,
      canvasH: null,
      isCom: 1,
      baseList: [
        {
          title: '文本',
          image: require('../assets/major/base/base_1.png')
        },
        {
          title: '表情',
          image: require('../assets/major/base/base_2.png')
        },
        {
          title: '图片',
          image: require('../assets/major/base/base_3.png')
        },
        {
          title: '语音',
          image: require('../assets/major/base/base_4.png')
        },
        {
          title: '视频',
          image: require('../assets/major/base/base_5.png')
        },
        {
          title: '音视频通话',
          image: require('../assets/major/base/base_6.png')
        },
        {
          title: '文件',
          image: require('../assets/major/base/base_7.png')
        },
        {
          title: '好友管理',
          image: require('../assets/major/base/base_8.png')
        },
        {
          title: '群管理',
          image: require('../assets/major/base/base_9.png')
        },
        {
          title: '更多',
          image: require('../assets/major/base/base_10.png')
        }
      ],
      featureList: [
        {
          title: '消息定时清理',
          image: require('../assets/major/feature/feature_1.png')
        },
        {
          title: '会话截屏通知',
          image: require('../assets/major/feature/feature_2.png')
        },
        {
          title: '消息24小时可撤回',
          image: require('../assets/major/feature/feature_3.png')
        },
        {
          title: '消息端对端加密',
          image: require('../assets/major/feature/feature_4.png')
        },
        {
          title: '消息引用回复',
          image: require('../assets/major/feature/feature_5.png')
        },
        {
          title: '群成员保护',
          image: require('../assets/major/feature/feature_6.png')
        },
        {
          title: '群主可撤回群成员消息',
          image: require('../assets/major/feature/feature_7.png')
        },
        {
          title: '群员全体禁言',
          image: require('../assets/major/feature/feature_8.png')
        },
        {
          title: '秘密好友',
          image: require('../assets/major/feature/feature_9.png')
        },
        {
          title: '更多',
          image: require('../assets/major/feature/feature_10.png')
        }
      ],
      open: false,
      form: {
        name: undefined,
        cell_phone: undefined,
        code: undefined
      },
      rules: {
        name: [{ required: true, message: '不能为空', trigger: 'blur' }],
        cell_phone: [{ required: true, message: '不能为空', trigger: 'blur' },
          { validator: checkPhone, trigger: 'blur' }],
        code: [{ required: true, message: '不能为空', trigger: 'blur' }]
      },
      showtext: '获取验证码',
      countNum: 60,
      codeshow: true,
      submitSuccess: false,
      wdithNum: '400px'
    }
  },
  mounted () {
    let host = window.location.href
    if (host.indexOf('mostonetech.com') > -1) {
      this.isCom = 30
    } else if (host.indexOf('mostonetech.top') > -1) {
      this.isCom = 2
    } else {
      this.isCom = 4
    }
    document.title = 'IM私有化部署-IM即时通讯软件私有化部署-默往专业版'
    let clientWidth = document.body.clientWidth || document.documentElement.clientWidth
    if (clientWidth < 500) {
      this.wdithNum = `90%`
    }
  },
  methods: {
    download (url) {
      window.location.href = url
    },
    loop () {
      this.ctx.clearRect(0, 0, this.canvasW, this.canvasH)
      this.ctx.fillStyle = 'rgba(61, 249, 193, 0.1)'
      this.ctx.fillRect(0, 0, this.canvasW, this.canvasH)

      for (let i = 0; i < this.animationObj.length; i++) {
        this.animationObj[i].draw(this.ctx)
        this.animationObj[i].update(this.ctx)
      }

      requestAnimationFrame(this.loop)
    },
    // 倒计时
    countDown () {
      // 更改btn状态
      this.codeshow = !this.codeshow
      // 设置倒计时
      this.intervalBtn = setInterval(() => {
        if (this.countNum <= 0) {
          // 清除定时器
          clearInterval(this.intervalBtn)
          // 更改btn状态
          this.codeshow = !this.codeshow
          // 重置倒计时状态
          this.countNum = 60
        }

        // 倒计时
        this.countNum--
      }, 1000)
    },
    getCodeAgain () {
      this.$message.warning('获取验证码频次过于频繁')
    },
    /** 获取验证码 */
    getCodeFn () {
      this.$refs['form'].validateField('cell_phone', (valid) => {
        if (!valid) {
          let params = {
            phone: this.form.cell_phone
          }
          getCode(params).then(res => {
            if (res.code === 200) {
              this.$message.success('发送成功')
              this.countDown()
              this.showtext = '重新获取'
            } else {
              this.$message.error(res.msg)
            }
          }).catch(() => {
            this.getCode()
          })
        }
      })
    },
    /** 提交咨询 */
    submitForm () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          addApply(this.form).then(res => {
            if (res.code === 200) {
              this.submitSuccess = true
            } else {
              this.$message.error(res.msg)
            }
          }).catch(err => {
            this.$message.error(err.msg)
          })
        }
      })
    },
    showDialog () {
      this.resetForm()
      this.open = true
    },
    resetForm () {
      this.form = {
        name: undefined,
        cell_phone: undefined,
        code: undefined
      }
    },
    closeFn () {
      this.open = false
      this.$refs['form'].clearValidate()
    },
    downloadh5 () {
      if (this.isWeiXin()) {
        // window.location.href =
        //   "https://sj.qq.com/myapp/detail.htm?apkName=com.mostone.life";
        window.location.href =
          'http://a.app.qq.com/o/simple.jsp?pkgname=com.mostone.life'
        // this.show = true;
        return
      }
      let channel = this.$route.query.channel
      var u = window.navigator.userAgent
      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS) {
        window.location.href = 'https://apps.apple.com/cn/app/id1408526658'
      } else {
        if (channel) {
          window.location.href = `http://okimg.mostonetech.top/apks/mostone_release_${channel}.apk`
        } else {
          window.location.href =
            'http://okimg.mostonetech.top/apks/mostone_release.apk'
        }
      }
    },
    isWeiXin () {
      var ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    }
  },
  destroyed () {
    window.onresize = null
  }
}
</script>

<style lang="scss">
@import "@/assets/css/style";

@media screen and (min-width: 1000px) {

  .page-container {
    width: 100%;
    background: rgba(61, 249, 193, 0.1);
    font-size: 16px;
    position: relative;

    .page-box {
      height: 790px;
    }

    .page-content {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      position: relative;
      display: flex;
      flex-direction: column;

      .btn-cls {
        width: 200px;
        height: 56px;
        background: #fff;
        border-radius: 30px;
        color: #000;
        line-height: 56px;
        font-size: 20px;
        display: inline-block;
        margin-top: 36px;
        cursor: pointer;
      }

      .btn-cls:hover {
        color: #fff;
        background: #00D394;
      }

      header {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        a {
          color: #fff;
          text-decoration: none;
          cursor: pointer;
          font-weight: bold;
          line-height: 1;
          font-size: 22px;
        }
      }

      .main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: calc(100% - 164px);
        box-sizing: border-box;

        .left-box {
          color: #fff;
          text-align: center;

          .text-cls {
            margin-top: 30px;
            line-height: 36px;
            font-size: 21px;
          }
        }

        .center-box {
          width: 450px;
        }

        .right {
          color: #fff;

          h1 {
            font-size: 40px;
            font-weight: bold;
            margin: 0;
          }

          p {
            font-size: 24px;
            margin: 0;
          }

          .btn {
            display: flex;
            align-items: center;

            .download {
              width: 120px;
              height: 44px;
              border-radius: 40px;
              background: #fff;
              color: #00D394;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 16px;
              font-weight: bold;
              margin: 25px 0;
              cursor: pointer;

              img {
                padding-right: 5px;
                position: relative;
                top: -2px;
              }

              &:hover {
                background: #24e8ae;
                color: #fff;
              }
            }

            .iphone {
              margin-right: 18px;
            }
          }

          .ph-box{
            display: none;
          }

          .qrcode {
            width: 120px;
            background: #fff;
            padding: 8px;
            box-sizing: border-box;
            border-radius: 8px;
            color: #7f7f7f;
            text-align: center;
            font-size: 14px;
            font-weight: bold;

            img {
              width: 100%;
            }
          }
        }
      }
    }

    .box-cls-1 {
      background: linear-gradient(180deg, #18CEB1 0%, #008D84 100%);
    }

    .box-cls-3 {
      background: linear-gradient(180deg, #00849C 0.01%, #165F75 100%);
    }

    .box-cls-2, .box-cls-3 {
      text-align: center;
      padding: 90px 0;
      height: auto !important;

      h1 {
        font-size: 40px;
      }

      .flex-1 {
        margin-top: 50px;
      }

      .item-title-cls {
        margin-top: 20px;
      }
    }

    .box-cls-3 {
      color: #fff;

      h4 {
        margin-top: 15px;
        font-size: 24px;
      }

      .btn-cls {
        margin: 60px auto 0;
      }
    }

    .flex-box {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;

      .flex-1 {
        width: 20%;
      }
    }

    footer {
      font-size: 12px;
      color: #B6B7BA;
      text-align: center;
      line-height: 1.8;
      padding: 16px 0;

      a {
        color: #B6B7BA;
        text-decoration: none;
      }
    }
  }

  .dialog-cls {
    text-align: center;
    border-radius: 20px !important;

    .el-dialog__header{
      font-weight: bold;
    }

    .btn-cls {
      width: 260px;
      height: 40px;
      background: #00D394;
      border-radius: 30px;
      color: #fff;
      line-height: 40px;
      font-size: 16px;
      display: inline-block;
      cursor: pointer;
    }

    .code-btn {
      background: #00D394;
      border: 1px solid #00D394;
    }

    .btn-tag-cls {
      color: #999;
      margin-top: 14px;
    }
  }

  .success-box{
    line-height: 1.6;
    i {
      font-size: 50px;
      color: #00D394;
    }
    .title-cls{
      font-size: 16px;
      color: #000;
      margin: 10px 0;
      font-weight: bold;
    }

    .success-tag {
      border-top: 1px solid #e5e5e5;
      margin-top: 14px;
      padding: 14px 0;
    }
  }
}

@media screen and (max-width: 999px) {
  .flex-box {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    .flex-1 {
      width: 33%;
    }
  }

  .page-container {
    background: rgba(61, 249, 193, 0.1);
    padding-bottom: px2rem(120);
  }

  .page-box {
    font-size: px2rem(32);
    text-align: center;
    color: #fff;
    width: 100%;

    header {
      padding: px2rem(28);
      text-align: left;

      img {
        width: px2rem(320);
      }

      a {
        display: none;
      }
    }

    h1 {
      font-size: px2rem(40);
      line-height: 1.6;
    }

    .left-box {
      padding: px2rem(60) 0;

      .btn-cls {
        display: none;
      }
    }

    .text-cls {
      margin-top: px2rem(30);
      font-size: px2rem(30);
      line-height: 1.8;
    }

    .center-box {
      width: 90%;
    }

    .right {
      .pc-box{
        display: none;
      }

      .ph-box{
        padding-bottom: px2rem(60);

        h1 {
          color: #fff;
          font-size: px2rem(50);
        }

        span {
          margin: 0 px2rem(10);
        }

        .down-btn-cls{
          display: inline-block;
          width: px2rem(280);
          height: px2rem(80);
          line-height: px2rem(80);
          background: #fff;
          border-radius: px2rem(60);
          font-weight: bold;
          font-size: px2rem(30);
          margin-top: px2rem(24);
          color: #00D394;
        }
      }
    }

    .flex-box {
      color: #000;
    }

    .flex-img-cls {
      width: px2rem(180);
    }

    .item-title-cls {
      padding: px2rem(30) 0;
    }

  }
  .box-cls-1 {
    background: linear-gradient(180deg, #18CEB1 0%, #008D84 100%);
  }

  .box-cls-3 {
    background: linear-gradient(180deg, #00849C 0.01%, #165F75 100%);
  }

  .box-cls-2, .box-cls-3 {
    h1 {
      color: #000;
      padding: px2rem(60) 0;
    }
  }
  .box-cls-3 {
    color: #fff;

    .flex-box {
      align-items: flex-start;
    }

    h1 {
      color: #fff;
      padding: px2rem(50) 0;
    }

    .item-title-cls {
      color: #fff;
    }

    h4 {
      padding-bottom: px2rem(50);
    }

    .bottom-btn{
      position: fixed;
      width: 100%;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 9;
      background: #00D394;
      height: px2rem(100);
      line-height: px2rem(100);
      text-align: center;
      padding-bottom: px2rem(40);
    }

    .btn-cls {
      background: #fff;
      color: #00D394;
      font-weight: bold;
      border-radius: px2rem(60);
      width: 90%;
      margin: px2rem(20) 0;
      display: inline-block;
    }

  }

  footer {
    font-size: px2rem(24);
    color: #B6B7BA;
    text-align: center;
    line-height: 1.8;
    padding: px2rem(32) 0;

    a {
      color: #B6B7BA;
      text-decoration: none;
    }
  }

  .dialog-cls {
    text-align: center;
    border-radius:px2rem(30) !important;

    .el-dialog__header{
      padding: 0 !important;
      font-weight: bold;
    }

    .btn-cls {
      width: 100%;
      height: px2rem(80);
      background: #00D394;
      border-radius: px2rem(60);
      color: #fff;
      line-height: px2rem(80);
      font-size: px2rem(32);
      display: inline-block;
    }

    .code-btn {
      background: #00D394;
      border: 1px solid #00D394;
    }

    .btn-tag-cls {
      color: #999;
      margin-top: 14px;
    }
  }

  .success-box{
    line-height: 1.6;
    i {
      font-size: px2rem(100);
      color: #00D394;
    }
    .title-cls{
      font-size: px2rem(32);
      color: #000;
      margin: px2rem(20) 0;
      font-weight: bold;
    }

    .success-tag {
      border-top: 1px solid #e5e5e5;
      margin-top: px2rem(28);
      padding: px2rem(28) 0;
    }
  }
}
</style>
